import { RichUtils, EditorState, Modifier } from 'draft-js';

export default {
    createLinkAtSelection(editorState, url) {
        const contentState = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', { url, target: '_blank' });
        const entityKey = contentState.getLastCreatedEntityKey();
        const selection = editorState.getSelection();

        const start = selection.getStartOffset();
        const end = selection.getEndOffset();

        if (start === end) {
            const nextContentState = Modifier.insertText(contentState, selection, url);
            const withLinkText = EditorState.push(editorState, nextContentState, 'insert-characters');
            const withLink = RichUtils.toggleLink(
                withLinkText,
                selection.merge({ focusOffset: end + url.length }),
                entityKey
            );
            return EditorState.forceSelection(withLink, nextContentState.getSelectionAfter());
        } else {
            const withLink = RichUtils.toggleLink(editorState, selection, entityKey);
            return EditorState.forceSelection(withLink, selection);
        }
    },

    removeLinkAtSelection(editorState) {
        const selection = editorState.getSelection();
        return RichUtils.toggleLink(editorState, selection, null);
    },

    getCurrentEntityKey(editorState) {
        const selection = editorState.getSelection();
        const anchorKey = selection.getAnchorKey();
        const contentState = editorState.getCurrentContent();
        const anchorBlock = contentState.getBlockForKey(anchorKey);
        const offset = selection.anchorOffset;
        const index = selection.isBackward ? offset - 1 : offset;
        return anchorBlock.getEntityAt(index);
    },

    getCurrentEntity(editorState) {
        const contentState = editorState.getCurrentContent();
        const entityKey = this.getCurrentEntityKey(editorState);
        return entityKey ? contentState.getEntity(entityKey) : null;
    },

    hasEntity(editorState, entityType) {
        const entity = this.getCurrentEntity(editorState);
        return entity && entity.getType() === entityType;
    },
};
